
import { PromoLine } from './promo-line-entity';
import { PromoPartnerFamilyPromo } from './promo-partner-family-promo.entity';
import { BaseEntity } from 'src/app/tools/models/baseEntity';


export class Promo extends BaseEntity {
  
  id                        : number;
  promoCode                 : string;
  name                      : string;
  description               : string;
  startDate                 : Date;
  endDate                   : Date;
  progressLevel             : number;
  sequence                  : number;
  skipToSequence            : number;
  breakPointType            : number;
  scaleMethod               : number;
  basedOnBurned             : boolean;
  burningPromo              : boolean;
  amount                    : number ;

  promoPartnerFamilyPromos  : PromoPartnerFamilyPromo[] = [];

  promoLines                : PromoLine[] = [];

  constructor() {
    super()
  }
}
 


